import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { BookingService } from '../../services/booking.service';

@Component({
  selector: 'laas-hscode-selector',
  templateUrl: './hscode-selector.component.html',
  styleUrls: ['./hscode-selector.component.scss'],
})
export class HSCodeSelectorComponent
  extends SessionBaseComponent
  implements OnInit
{
  @Input() bookingNo: string;
  @Output() dataTransferEvent: EventEmitter<any>;
  skuDescriptionOptions: any[];
  form: FormGroup;
  updateParams: any;

  constructor(
    injector: Injector,
    private bookingService: BookingService,
    private fb: FormBuilder
  ) {
    super(injector);
    this.dataTransferEvent = new EventEmitter<any>();
    this.form = this.fb.group({
      dhlInvoiceUpdateHsCodeBeanList: this.fb.array([]),
    });
    this.bookingNo = "";
    this.skuDescriptionOptions = [];
    this.updateParams = {};
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    let request = { bookingNo: this.bookingNo };
    this.bookingService.getDHLInvoiceSkuDescriptionOptions(request).subscribe({
      next: (options: any[]) => {
        this.skuDescriptionOptions = options.map(x => ({
          originalSkuDescription: x.skuDescription,
          modifiedSkuDescription: x.skuDescription,
          modifiedHsCode: x.hsCode
        }));

        this.skuDescriptionOptions.forEach((x) => {

          const group = this.fb.group({
            originalSkuDescription: x.originalSkuDescription,
            modifiedSkuDescription: [x.modifiedSkuDescription, Validators.required],
            modifiedHsCode: [x.modifiedHsCode, Validators.required]
          });

          (this.form.controls.dhlInvoiceUpdateHsCodeBeanList as FormArray).push(
            group
          );
        });
      },
    });
  }

  confirmBtnClick(event: any): void {
    this.form.addControl('bookingNo', new FormControl(this.bookingNo));
    this.form.addControl('updateUser', new FormControl(this.userProfile.userName));
    const request = { ...this.form.value }; //轉換form表單成一般物件
    if (this.isCheckNotPassed(request)) return;

    this.bookingService.updateDHLInvoiceHsCode(request).subscribe({
      next: (result) => {
        this.toastService.success('資料更新完成!!');
        this.dataTransferEvent.emit({ originalEvent: event });
      },
      error: (err) => {
        this.toastErrorMessage(err.error);
      },
    });
  }

  isCheckNotPassed(request: any): boolean {
    let hasInvalidSkuDescription = false;
    hasInvalidSkuDescription = request.dhlInvoiceUpdateHsCodeBeanList.reduce((acc: string[], curr: any) => {
      if (acc.includes(curr.modifiedSkuDescription) || isNullOrEmpty(curr.modifiedSkuDescription)) {
        return true;
      } else {
        acc.push(curr.modifiedSkuDescription);
        return acc;
      }
    }, []);

    if (hasInvalidSkuDescription == true) {
      this.toastService.error('Sku Description不能重複或為空');
      return true;
    } else {
      return false;
    }

  }
}
